import { render, staticRenderFns } from "./DonorBlock.vue?vue&type=template&id=61ae9c60&"
import script from "./DonorBlock.vue?vue&type=script&lang=js&"
export * from "./DonorBlock.vue?vue&type=script&lang=js&"
import style0 from "./DonorBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports